// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LegalRestriction
 */
export interface LegalRestriction {
  /**
   *
   */
  url: string;
  /**
   *
   */
  description: string;
}

/**
 * Check if a given object implements the LegalRestriction interface.
 */
export function instanceOfLegalRestriction(value: object): value is LegalRestriction {
  if (!("url" in value) || value["url"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined) return false;
  return true;
}

export function LegalRestrictionFromJSON(json: any): LegalRestriction {
  return LegalRestrictionFromJSONTyped(json, false);
}

export function LegalRestrictionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LegalRestriction {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
    description: json["description"],
  };
}

export function LegalRestrictionToJSON(json: any): LegalRestriction {
  return LegalRestrictionToJSONTyped(json, false);
}

export function LegalRestrictionToJSONTyped(
  value?: LegalRestriction | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
    description: value["description"],
  };
}
